let historyTabs = $('.history-tabs');

if (historyTabs.length) {

    historyTabs.each(function() {

        let $this = $(this),
            tabButtons = $this.find('.timeline-tab-button'),
            nextButtons = $this.find('.timeline-next-button'),
            prevButtons = $this.find('.timeline-prev-button');

        tabButtons.on('click', function() {

            tabButtons.not(this).removeClass('active');
            $(this).addClass('active');

            let index = $(this).data('timeline-index');
            $('.timeline-tab').not('.timeline-tab-' + index).removeClass('showing');
            setTimeout(function() {
                $('.timeline-tab').not('.timeline-tab-' + index).removeClass('active');
                $('.timeline-tab-' + index).addClass('active');
            }, 300);

            setTimeout(function() {
                $('.timeline-tab-' + index).addClass('showing');
            }, 400);

        });

        nextButtons.on('click', function() {
            let newIndex = $(this).data('timeline-index');
            $('.timeline-tab-button-' + newIndex).trigger('click');
        });

        prevButtons.on('click', function() {
            let newIndex = $(this).data('timeline-index');
            $('.timeline-tab-button-' + newIndex).trigger('click');
        });

    });

}
